import { render } from "./CalendarWeek.vue?vue&type=template&id=86c0cce4&scoped=true"
import script from "./CalendarWeek.vue?vue&type=script&lang=js"
export * from "./CalendarWeek.vue?vue&type=script&lang=js"

import "./CalendarWeek.vue?vue&type=style&index=0&id=86c0cce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c0cce4"]])

export default __exports__